var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickBooksLogo32X32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#2CA01C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9849 24C20.3948 24 23.9698 20.4183 23.9698 16C23.9698 11.5817 20.3948 8 15.9849 8C11.575 8 8 11.5817 8 16C8 20.4183 11.575 24 15.9849 24Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2168 16.0001C10.2168 17.7183 11.607 19.1115 13.3222 19.1115H13.7665V17.9555H13.3222C12.2463 17.9555 11.3698 17.079 11.3698 16.0001C11.3698 14.9211 12.2448 14.0447 13.3222 14.0447H14.3876V20.0892C14.3876 20.7269 14.9044 21.2453 15.5406 21.2453V12.8886H13.3222C11.607 12.8886 10.2168 14.2819 10.2168 16.0001ZM18.6475 12.8886H18.2032V14.0447H18.6475C19.7234 14.0447 20.5999 14.9226 20.5999 16.0001C20.5999 17.0775 19.7234 17.9555 18.6475 17.9555H17.5806V11.9109C17.5806 11.2732 17.0638 10.7549 16.4276 10.7549V19.11H18.6475C20.3626 19.11 21.7529 17.7167 21.7529 15.9986C21.7529 14.2804 20.3626 12.8886 18.6475 12.8886Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 4,
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickBooksLogo32X32);
export default __webpack_public_path__ + "static/media/QuickBooks-Logo-32x32.806ef212.svg";
export { ForwardRef as ReactComponent };